module.exports = __webpack_public_path__ + "static/media/CargoCompactOnline_GeneralCondition_it.2ff7718c.pdf";